import "./play.css";
import { Chessboard } from "react-chessboard";
import Chess from "chess.js";
import { useEffect, useState } from "react";
import { getMoveOptions } from "../actions/get-move-options";
import { useAppContext } from "../../App/AppProvider";
import { usePlayContext } from "../PlayController";
import { getMovesFromPGN } from "../actions/get-moves-from-pgn";
import { ResetOrStartBtns } from "./reset-start-buttons";
import { DigitalGame, Game, digitalGameDefaults } from "../../../Types/Game";
import { useNavigate } from "react-router-dom";
import { alterGame } from "../../../ServerManager";
export interface Move {
  from: string | null;
  to: string | null;
  promotion: 'q';
}
const moveDefaults: Move = {
  from: null,
  to: null,
  promotion: 'q',
}
export const Play = () => {
  const navigate = useNavigate();
  // const { localVillagerUser } = useAppContext();
  const { selectedGame, updateSelectedGame, usersActiveGames, setUsersActiveGames, resetUserGames,
    selectedRange, setSelectedRange, orientation, setOrientation, review, setReview } = usePlayContext()
  const [game, setGame] = useState(new Chess());
  const [optionSquares, setOptionSquares] = useState({});
  const [moveSquares, setMoveSquares] = useState({});
  const [matchReady, setMatchReady] = useState<boolean>(false);
  const [reviewPgn, setReviewPgn] = useState<string[]>([]);
  const [reviewLength, setReviewLength] = useState(0);
  const [playerMove, updatePlayerMove] = useState<Move>({ ...moveDefaults })

  useEffect(
    () => {
      document.addEventListener('click', leaveGame);

      // Clean up the event listener
      // return () => {
      //   document.removeEventListener('click', leaveGame);
      // };
    }, []
  )
  useEffect(
    () => {
      if (selectedGame) {
        if (selectedGame.pgn) {
          game.load_pgn(selectedGame.pgn);
        }
        setMatchReady(true);
      }
    }, [selectedGame]
  )
  useEffect(
    () => {
      const pgnArr: string[] = getMovesFromPGN(game);
      setReviewPgn(pgnArr);
      if (pgnArr.length) {
        setReviewLength(pgnArr.length);
      }
    }, [review, game]
  )

  useEffect(
    () => {
      if (playerMove.from) {
        const hasOptions: { hasOptions: boolean, newSquares: any } = getMoveOptions(playerMove.from, game);
        setOptionSquares(hasOptions.newSquares);
      }
      if (playerMove.from && playerMove.to) {
        makeAMove({
          from: playerMove.from,
          to: playerMove.to,
          promotion: "q", // always promote to a queen for example simplicity
        });
        const newPgn = game.pgn();
        const gameCopy = { ...selectedGame };
        gameCopy.pgn = newPgn;
        updateSelectedGame(gameCopy);
        alterGame(gameCopy)
          .then((data: DigitalGame) => {
            setUsersActiveGames(usersActiveGames.map(game => game.id === data.id ? data : game));
          });
        resetMove();
        setOptionSquares({});
      }
    }, [playerMove]
  )

  function resetMove() {
    updatePlayerMove({ ...moveDefaults });
  }

  function resetGame() {
    game.reset(); //TODO: DO WE WANT THIS
    setOptionSquares({});
    resetMove();
  }

  function makeAMove(move: any) {
    const gameCopy = { ...game };
    const result = gameCopy.move(move);
    setGame(gameCopy);
    return result; // null if the move was illegal, the move object if the move was legal
  }

  // function makeRandomMove() {
  //   const possibleMoves = game.moves();
  //   if (game.game_over() || game.in_draw() || possibleMoves.length === 0)
  //     return; // exit if the game is over
  //   const randomIndex = Math.floor(Math.random() * possibleMoves.length);
  //   makeAMove(possibleMoves[randomIndex]);
  // }

  function onDrop(sourceSquare: any, targetSquare: any) {
    const move = makeAMove({
      from: sourceSquare,
      to: targetSquare,
      promotion: "q", // always promote to a queen for example simplicity
    });

    // illegal move
    if (move === null) return false;
    // setTimeout(makeRandomMove, 200);
    return true;
  }

  const handleSquareClick = (square: any) => {
    if (!playerMove.from) {
      updatePlayerMove({ ...playerMove, from: square });
    } else {
      updatePlayerMove({ ...playerMove, to: square });
    }
  }
  const leaveGame = (e: Event) => {
    if (e.target) {
      const target = e.target as HTMLElement;

      if (document.getElementById("navMenu")?.contains(target)) {
        if (target.className !== "menu-btn" && target.id !== "inactive" && target.id !== "active" && target.id !== "navMenu" && target.id !== "navLinks" && target.id !== "logo" && target.className !== "" && target.id !== "play") {
          updateSelectedGame({ ...digitalGameDefaults });
          document.removeEventListener('click', leaveGame);
          // setReview(false)
          navigate((e.target as HTMLElement).id);
        }
      }
      if (target.id === "logout") {
        updateSelectedGame(digitalGameDefaults);
        // setReview(false);
        localStorage.removeItem("villager");
        document.removeEventListener('click', leaveGame);
        navigate("/", { replace: true });
      }
    }
  }

  // console.log(Object.keys(<Chessboard />))

  return <>
    <div id="playContainer">
      <div id="boardInterface">
        <Chessboard
          boardOrientation={orientation}
          animationDuration={300}
          position={game.fen()}
          onPieceDrop={onDrop}
          onSquareClick={(evt: any) => {
            handleSquareClick(evt);
          }}
          customBoardStyle={{
            borderRadius: "4px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
          }}
          customSquareStyles={{
            ...moveSquares,
            ...optionSquares,
          }} />
        <ResetOrStartBtns
          selectedGame={selectedGame}
          matchReady={matchReady}
          handleGameReset={resetGame}
          review={review}
          reviewLength={reviewLength}
          setReviewLength={setReviewLength}
          reviewPgn={reviewPgn}
        />
      </div>
    </div>
  </>
}

// export const Play = () => {
//   const { localVillagerUser, clubMatesAndGuests } = useAppContext();
//   const { selectedGame, updateSelectedGame, orientation, review, setReview, resetUserGames } = usePlayContext();
//   const navigate = useNavigate();
//   const [game, setGame] = useState(new Chess());
//   const [matchReady, setMatchReady] = useState(false);
//   const [reviewPgn, setReviewPgn] = useState<string[]>([]);
//   const [reviewLength, setReviewLength] = useState(0);
//   const [stringPgn, setStringPgn] = useState<string>("");
//   const [gameForApi, updateGameForApi] = useState<DigitalGame>(digitalGameDefaults);
//   const [moveFrom, setMoveFrom] = useState("");
//   const [optionSquares, setOptionSquares] = useState({});
//   const [moveSquares, setMoveSquares] = useState({});

//   useEffect(
//     () => {
//       console.log('game', game)
//       console.log('game.game_over()', game.game_over())
//     }, [game]
//   )
//   useEffect(
//     () => {
//       if (selectedGame) {
//         if (selectedGame.pgn) {
//           game.load_pgn(selectedGame.pgn);
//         }
//         updateGameForApi(selectedGame);
//         setMatchReady(true);
//       } else {
//         const copy: DigitalGame = { ...digitalGameDefaults };
//         if (orientation === "black") {
//           const userObject = findByIdentifier(localVillagerUser.userId, clubMatesAndGuests);
//           if (userObject) {
//             copy.player_b = userObject;
//             copy.player_w = null
//             // copy.computer_opponent = true
//             updateGameForApi(copy)
//           }
//         }
//         else {
//           copy.player_w = localVillagerUser.userId;
//           copy.player_b = null;
//           // copy.computer_opponent = true;
//           updateGameForApi(copy)
//         }
//       }

//     }, [selectedGame, orientation, game, clubMatesAndGuests, localVillagerUser]
//   )

//   //this is likely what was causing the bug
//   useEffect(
//     () => {
//       if (selectedGame.id) {
//         if (selectedGame.winner === null) {
//           if (game.game_over()) {
//             console.log('inuseEffect', game.game_over())
//             const copy = { ...selectedGame };
//             copy.pgn = game.pgn();
//             if (game.in_checkmate()) {
//               if (game.turn() === "b") {
//                 copy.winner = selectedGame.player_w;
//                 copy.winner_model_type = 'player';
//               } else {
//                 copy.winner = selectedGame.player_b;
//                 copy.winner_model_type = 'player';
//               }
//               copy.win_style = 'checkmate';
//             } else {
//               copy.win_style = "draw";
//             }
//             updateGameForApi(copy);
//             if (selectedGame.id) {
//               //TODO-COMMENT
//               console.log('game over useEffect', selectedGame)
//               // alterGame(copy)
//               //   .then(() => resetUserGames());
//             }
//           }
//         }
//       }
//     }, [game, selectedGame]
//   )

//   useEffect(
//     () => {
//       if (review) {
//         const pgnArr: string[] = getMovesFromPGN(game);
//         setReviewPgn(pgnArr);
//         if (pgnArr.length) {
//           setReviewLength(pgnArr.length);
//         }
//       }
//     }, [review, game, /*selectedGame*/]
//   )

//   useEffect(
//     () => {
//       if (reviewLength > 0) {
//         const newPgn = [...reviewPgn];
//         const stringPgn = pgnStringBuilder(newPgn, reviewLength);
//         setStringPgn(stringPgn);
//         game.load_pgn(stringPgn);
//       }
//     }, [reviewLength, reviewPgn, game]
//   )
//   //  TODO: DO WE NEED THIS?
//   const safeGameMutate = (modify: any) => {
//     // console.log('modify', modify)
//     setGame((g: any) => {
//       // console.log('g', g)
//       const update = { ...g };
//       modify(update);
//       return update;
//     });
//   }
//   const onSquareClick = (square: any) => {
//     // console.log('square', square)
//     // setRightClickedSquares({});
//     // console.log('outer square', square)
//     function resetFirstMove(square: any) {
//       // console.log('square', square)
//       // console.log('within move reset')
//       const hasOptions: { hasOptions: boolean, newSquares: any } = getMoveOptions(square, game);
//       setOptionSquares(hasOptions.newSquares);
//       // console.log('gamemoves in component', game.moves({
//       //   square,
//       //   verbose: true,
//       // }))
//       // console.log('hasOptions', hasOptions)
//       if (hasOptions.hasOptions) setMoveFrom(square);
//     }
//     // from square
//     if (!moveFrom) {
//       // console.log('in !moveFrom')
//       resetFirstMove(square);
//       return;
//     }
//     // attempt to make move
//     // const gameCopy = { ...game };
//     // const move = gameCopy.move({
//     //   from: moveFrom,
//     //   to: square,
//     //   promotion: "q", // TODO: CURRENTLY PROMOTING TO QUEEN ONLY. always promote to a queen for example simplicity
//     // });
//     // const gameCopy = { ...game };
//     const move = game.move({
//       from: moveFrom,
//       to: square,
//       promotion: "q", // TODO: CURRENTLY PROMOTING TO QUEEN ONLY. always promote to a queen for example simplicity
//     });
//     // console.log('move', move)
//     // console.log('gameCopy', gameCopy)
//     // console.log('gameCopy.moves()', gameCopy.moves())
//     // setGame(gameCopy);
//     // if invalid, setMoveFrom and getMoveOptions
//     if (move === null) {
//       resetFirstMove(square);
//       return;
//     }
//     setMoveFrom("");
//     setOptionSquares({});
//     const newGame = new Chess(game.pgn());
//     setGame(newGame);
//   }
//   const resetOrStartGame = () => {
//     if (!selectedGame.id) {
//       if (matchReady) {
//         return (
//           <div>
//             <button
//               className="buttonStyleApprove playBtns"
//               onClick={() => {
//                 safeGameMutate((game: any) => {
//                   game.reset();
//                 });
//                 setMoveSquares({});
//               }}
//             >reset</button>
//           </div>
//         )
//       }
//       else {
//         return null
//       }
//     }
//     else {
//       if (review === true) {
//         return (
//           <div>
//             <button className="reviewButtons"
//               onClick={() => {
//                 setReviewLength(reviewLength - 1)
//               }}>&lt;</button>
//             <button className="reviewButtons"
//               onClick={() => {
//                 if (reviewLength < reviewPgn.length) {
//                   setReviewLength(reviewLength + 1)
//                 }
//               }}>&gt;</button>
//           </div>
//         )
//       }
//     }
//   }
//   const leaveGame = (e: Event) => {
//     if (e.target) {
//       const target = e.target as HTMLElement;

//       if (document.getElementById("navMenu")?.contains(target)) {
//         if (target.className !== "menu-btn" && target.id !== "inactive" && target.id !== "active" && target.id !== "navMenu" && target.id !== "navLinks" && target.id !== "logo" && target.className !== "" && target.id !== "play") {
//           updateSelectedGame(digitalGameDefaults);
//           document.removeEventListener('click', leaveGame);
//           // setReview(false)
//           navigate((e.target as HTMLElement).id);
//         }
//       }
//       if (target.id === "logout") {
//         updateSelectedGame(digitalGameDefaults);
//         // setReview(false);
//         localStorage.removeItem("villager");
//         document.removeEventListener('click', leaveGame);
//         navigate("/", { replace: true });
//       }
//     }
//   }
//   document.addEventListener('click', leaveGame);

//   return (
//     <main id="playContainer">
//       {!selectedGame.id && !matchReady ?
//         <div id="clickStartPrompt"
//           onClick={() => setMatchReady(true)}>
//           <div>Start Game</div>
//         </div>
//         : ""}
//       {!selectedGame.id ?
//         game.in_check() ?
//           <div>check</div> :
//           game.game_over() && game.in_checkmate() ?
//             <div id="checkmatePrompt">
//               <div>checkmate</div>
//               <button onClick={() => {
//                 updateSelectedGame(digitalGameDefaults);
//                 navigate("/");
//               }}>
//                 exit game
//               </button>
//             </div>
//             : ""
//         : ""}
//       <div id="boardInterface">
//         <Chessboard
//           // key={game.fen()}
//           id="ClickToMove"
//           animationDuration={200}
//           arePiecesDraggable={false}
//           boardOrientation={orientation}
//           position={game.fen()}
//           onSquareClick={(evt) => {
//             // console.log('hitting')
//             // console.log('evt', evt)
//             if (matchReady) {
//               onSquareClick(evt)
//               if (selectedGame.id) {
//                 console.log('getting past if')
//                 const gameCopy = { ...selectedGame }
//                 const newPgn = game.pgn();
//                 gameCopy.pgn = newPgn;
//                 alterGame(gameCopy)
//                   .then(() => resetUserGames());
//               }
//             }
//           }}
//           customBoardStyle={{
//             borderRadius: "4px",
//             boxShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
//           }}
//           customSquareStyles={{
//             ...moveSquares,
//             ...optionSquares,
//           }}
//         />
//         <div id="playControls" >
//           {resetOrStartGame()}
//           <button
//             className="buttonStyleApprove playBtns"
//             onClick={() => {
//               safeGameMutate((game: any) => {
//                 game.undo();

//               });
//               setMoveSquares({});
//             }}
//           >
//             undo
//           </button>
//           <button

//             className="buttonStyleReject playBtns"
//             onClick={() => {
//               updateSelectedGame(digitalGameDefaults)
//               navigate(-1)
//             }}>
//             exit game
//           </button>
//         </div>
//       </div>
//     </main>
//   )
// }
// // export const Play = () => {
// //   return <></>
// // }